'use client';

export function ReviewsWidget() {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold dark-text">What Our Customers Say</h2>
          <p className="text-gray-600 mt-3 max-w-2xl mx-auto">
            We&apos;re building our reputation one project at a time. Check back soon for verified customer reviews.
          </p>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://www.google.com/search?q=erroll+scheurer+plastering"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-6 py-3 rounded-md text-white font-medium hover:opacity-90 transition-opacity"
            style={{ backgroundColor: 'var(--color-primary)' }}
          >
            See Our Google Reviews →
          </a>
        </div>
      </div>
    </section>
  );
}
